
import { defineComponent, computed, watch, ref } from "vue";
import TablesWidget from "@/components/widgets/Table/TablesWidget.vue";
import KTToolbar from "@/layout/toolbar/Toolbar.vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { useRoute, onBeforeRouteLeave } from "vue-router";
import FormModal from "@/components/modals/FormModal.vue";
export default defineComponent({
  name: "ListPage",
  components: {
    TablesWidget,
    KTToolbar,
    FormModal,
  },
  props: {
    key: String,
  },
  setup(props) {
    const store = useStore();
    let route = useRoute();
    const setupList = (key?: string) => {
      if (!key) return;
      store.dispatch(Actions.SETUP_LIST, { key });
      store.dispatch(Actions.SET_IS_FROM_LIST, {
        key,
        flag: true,
      });
    };
    watch(
      () => route.meta.key,
      async (newKey) => {
        setupList(newKey as string);
      }
    );
    const key = ref(route.meta.key);

    //const router = useRouter();
    /****** COMPUTED ******/
    const mapping = computed(() => {
      return store.getters.getMapping({ key: getKey.value });
    });

    const breadcrumbs = computed(() => {
      return store.getters.pageBreadcrumbPath;
    });
    const getMultipleFormEdit = computed(() => {
      return store.getters.getMultipleFormEdit({ key: getKey.value });
    });

    /****** ACTIONS ******/

    setupList(route.meta.key as string);

    const getKey = computed(() => {
      return useRoute().meta.key;
    });
    // watch(routeTest, (routeTest) => {

    // });
    // watch(route, (newRoute) => {
    //   // if (newRoute.path.includes("list")) {
    //   //   //if (newRoute.path != route.path) {
    //   //   store.dispatch(Actions.SETUP_LIST, {
    //   //     key: newRoute.meta.key,
    //   //   });
    //   //   store.dispatch(Actions.SET_IS_FROM_LIST, {
    //   //     key: newRoute.meta.key,
    //   //     flag: true,
    //   //   });
    //   //   //}
    //   // }
    // });

    onBeforeRouteLeave(async (to, from, next) => {
      // only fetch the user if the id changed as maybe only the query or the hash changed
      // if (to.path.includes("list")) {
      //   // key.value = to.meta.key;
      //   //next(to);
      // } else {
      //   //next(to);
      // }
      // if (to.path.includes("list")) {
      //   store.dispatch(Actions.SETUP_LIST, {
      //     key: to.meta.key,
      //   });
      //   store.dispatch(Actions.SET_IS_FROM_LIST, {
      //     key: to.meta.key,
      //     flag: true,
      //   });
      // }
      next();
    });
    return {
      mapping,
      breadcrumbs,
      route,
      getKey,
      getMultipleFormEdit,
    };
  },
});
